import React from "react";
import Title from "../../../../Universal/Title.component";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import UniversalLineChartComponent from "../../../../Universal/UniversalLineChartComponent";

const AttendanceGraph = ({ graphTitle, graphFilter, graphData }) => {
  return (
    <div className="flex-col align-start justify-start g-1 radius-6 p-2 back-white">
      <div className="flex-row align-center justify-between g-1">
        <Title>{graphTitle}</Title>
        <SelectFilter setFieldValue={(val) => graphFilter(val)} />
      </div>
      <UniversalLineChartComponent
        data={graphData}
        lines={[
          { dataKey: "blueLine", name: "Sales", stroke: "#3888FF" },
          { dataKey: "redLine", name: "Revenue", stroke: "#FF6464" },
        ]}
        xAxisKey="date"
        referenceLinesValue={50}
      />
    </div>
  );
};

export default AttendanceGraph;
